<template>
  <v-dialog v-model="visible" max-width="800">
    <v-card class="refund-record-dialog">
      <v-card-title class="dialog-header">
        <div class="header-left">
          <span class="title-bar"></span>
          <span class="dialog-title-text">退保记录</span>
        </div>
        <div class="header-right">
          <span class="status-badge" :class="getStatusClass(info.coverStatus)">{{ info.coverStatusStr }}</span>
          <v-btn icon small class="close-btn" @click="close">
            <v-icon small>close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="dialog-body">
        <!-- 退保基本信息 -->
        <div class="refund-info-section">
          <div class="info-grid">
            <div class="info-item">
              <span class="label">保单号：</span>
              <span class="value">{{ info.insurerPolicyCode }}</span>
            </div>
            <div class="info-item">
              <span class="label">投保人：</span>
              <span class="value">{{ info.name }}</span>
            </div>
            <div class="info-item">
              <span class="label">退保日期：</span>
              <span class="value">{{ info.urrenderTime }}</span>
            </div>
            <div class="info-item">
              <span class="label">处理状态：</span>
              <span class="value highlight">{{ info.coverStatusStr }}</span>
            </div>
          </div>
        </div>

        <!-- 退保人员列表 -->
        <div class="section-title">退保人员列表</div>
        <div class="table-wrapper">
          <div v-if="loading" class="loading-mask">
            <v-progress-circular indeterminate color="#dd122a"></v-progress-circular>
          </div>
          <table class="person-table">
            <thead>
              <tr>
                <th>姓名</th>
                <th>证件类型</th>
                <th>证件号码</th>
                <th>保障方案</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(person, index) in personList" :key="index">
                <td>{{ person.name }}</td>
                <td>{{ person.certTypeStr }}</td>
                <td>{{ person.certNo }}</td>
                <td>{{ person.planShortName }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分页 -->
        <div class="dialog-pagination" v-if="totalCount > 0">
          <v-pagination
            v-model="currentPage"
            :length="totalPages"
            :total-visible="7"
            color="#dd122a"
            @input="loadCancelPersonList"
          ></v-pagination>
        </div>

        <!-- 费用结算明细 -->
        <div class="section-title">费用结算明细</div>
        <div class="fee-section">
          <div class="fee-item">
            <span class="fee-label">应退保费（未起保全额退/后台退款）</span>
            <span class="fee-value">¥{{ info.urrenderPremium }}</span>
          </div>
          <div class="fee-item total">
            <span class="fee-label">实际退款金额</span>
            <span class="fee-value highlight">¥{{ info.urrenderPremium }}</span>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getCancelInsuredList } from '@/api/travelInsurance';

export default {
  name: 'RefundRecordDialog',
  data() {
    return {
      visible: false,
      info: {},
      personList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
    };

  },
  methods: {
    onLoad(info){
      this.info = info;
      this.visible = true;
      this.loadCancelPersonList();
    },
    loadCancelPersonList() {
      this.loading = true;
      const params = {
        policyId: this.info.id,
        pageIndex: this.currentPage,
        pageSize: this.pageSize
      };
      getCancelInsuredList(params).then(res => {
        if (res.code === 0 || res.success) {
          const pageData = res.data || {};
          this.personList = pageData.records || [];
          this.totalCount = pageData.total || 0;
          this.totalPages = pageData.pages || 1;
        }
      }).catch(err => {
        console.error('获取退保人员列表失败:', err);
      }).finally(() => {
        this.loading = false;
      });
    },
    close() {
      this.visible = false;
      this.currentPage = 1;
      this.info = {};
    },
    getStatusClass(status) {
      const statusMap = {
        0: 'status-pending',
        5: 'status-active',
        9: 'status-expired',
        8: 'status-canceled'
      };
      return statusMap[status] || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.refund-record-dialog {
  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid #e8e8e8;

    .header-left {
      display: flex;
      align-items: center;
      gap: 8px;

      .title-bar {
        width: 4px;
        height: 16px;
        background-color: #dd122a;
        border-radius: 2px;
      }

      .dialog-title-text {
        font-size: 16px;
        font-weight: 500;
        color: #333;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 12px;

      .status-badge {
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;

        &.status-pending {
          background-color: #DBEAFE;
          color: #007DFF;
        }

        &.status-active {
          background-color: #DCFCE8;
          color: #18813E;
        }

        &.status-expired {
          background-color: #FDF1F2;
          color: #DD122A;
        }

        &.status-canceled {
          background-color: #EEEEEE;
          color: #93969B;
        }
      }

      .close-btn {
        width: 28px;
        height: 28px;

        .v-icon {
          color: #999;
          font-size: 18px;
        }

        &:hover .v-icon {
          color: #666;
        }
      }
    }
  }

  .dialog-body {
    padding: 20px;

    .refund-info-section {
      margin-bottom: 20px;
      padding-bottom: 16px;
      border-bottom: 1px solid #f0f0f0;

      .info-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;

        .info-item {
          font-size: 13px;

          .label {
            color: #666;
          }

          .value {
            color: #333;

            &.highlight {
              color: #dd122a;
            }
          }
        }
      }
    }

    .section-title {
      font-size: 14px;
      font-weight: 500;
      color: #333;
      margin-bottom: 12px;
      padding-left: 8px;
      border-left: 3px solid #dd122a;
    }

    .table-wrapper {
      margin-bottom: 20px;
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      overflow: hidden;
      overflow-x: auto;
      position: relative;

      .loading-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
      }
    }

    .person-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;

      thead {
        background-color: #F5F5F5;

        th {
          padding: 12px 8px;
          text-align: center;
          font-weight: 500;
          color: #333;
          border-bottom: 1px solid #e8e8e8;
          white-space: nowrap;
        }
      }

      tbody {
        tr {
          border-bottom: 1px solid #e8e8e8;

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            background-color: #fafafa;
          }

          td {
            padding: 12px 8px;
            text-align: center;
            vertical-align: middle;
            color: #333;
          }
        }
      }
    }

    .fee-section {
      background-color: #f9f9f9;
      border-radius: 8px;
      padding: 16px;

      .fee-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px dashed #e0e0e0;

        &:last-child {
          border-bottom: none;
        }

        &.total {
          margin-top: 8px;
          padding-top: 16px;

          .fee-label {
            font-size: 15px;
            font-weight: 500;
            color: #333;
          }

          .fee-value {
            font-size: 18px;
            font-weight: 500;
          }
        }

        .fee-label {
          font-size: 14px;
          color: #666;
        }

        .fee-value {
          font-size: 14px;
          color: #333;

          &.highlight {
            color: #dd122a;
          }
        }
      }
    }

    .dialog-pagination {
      display: flex;
      justify-content: flex-end;
      margin-top: 16px;
    }
  }
}
</style>
